module.exports = [{
      plugin: require('/home/ubuntu/asphalt/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
